/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateWhatsAppResolveTemplateParameters } from '../../axios/candidateWhatsAppResolveTemplateParameters'
import type {
	CandidateWhatsAppResolveTemplateParametersError,
	CandidateWhatsAppResolveTemplateParametersPathParams,
	CandidateWhatsAppResolveTemplateParametersResponse,
} from '../../types/CandidateWhatsAppResolveTemplateParameters'

export const candidateWhatsAppResolveTemplateParametersQueryKey = (
	candidateId: CandidateWhatsAppResolveTemplateParametersPathParams['candidateId'],
	templateId: CandidateWhatsAppResolveTemplateParametersPathParams['templateId'],
) => [{
	url: '/candidates/:candidateId/whatsapp-templates/:templateId/parameters',
	params: { candidateId, templateId },
}] as const

export type CandidateWhatsAppResolveTemplateParametersQueryKey = ReturnType<
	typeof candidateWhatsAppResolveTemplateParametersQueryKey
>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::resolveTemplateParameters */
export function candidateWhatsAppResolveTemplateParametersQueryOptions(
	candidateId: CandidateWhatsAppResolveTemplateParametersPathParams['candidateId'],
	templateId: CandidateWhatsAppResolveTemplateParametersPathParams['templateId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidateWhatsAppResolveTemplateParametersResponse,
		AxiosError<CandidateWhatsAppResolveTemplateParametersError>,
		CandidateWhatsAppResolveTemplateParametersResponse,
		CandidateWhatsAppResolveTemplateParametersQueryKey
	>({
		queryKey: candidateWhatsAppResolveTemplateParametersQueryKey(candidateId, templateId),
		queryFn: ({ signal }) =>
			candidateWhatsAppResolveTemplateParameters(candidateId, templateId, { signal, ...config }).then(res =>
				res.data
			),
		enabled: !!(candidateId && templateId),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::resolveTemplateParameters */
export function useCandidateWhatsAppResolveTemplateParameters<
	TSelectData = CandidateWhatsAppResolveTemplateParametersResponse,
>(
	candidateId: CandidateWhatsAppResolveTemplateParametersPathParams['candidateId'],
	templateId: CandidateWhatsAppResolveTemplateParametersPathParams['templateId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateWhatsAppResolveTemplateParametersResponse,
					AxiosError<CandidateWhatsAppResolveTemplateParametersError>,
					TSelectData,
					CandidateWhatsAppResolveTemplateParametersQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateWhatsAppResolveTemplateParametersError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateWhatsAppResolveTemplateParametersQueryOptions(candidateId, templateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::resolveTemplateParameters */
export function useCandidateWhatsAppResolveTemplateParametersSuspense<
	TSelectData = CandidateWhatsAppResolveTemplateParametersResponse,
>(
	candidateId: CandidateWhatsAppResolveTemplateParametersPathParams['candidateId'],
	templateId: CandidateWhatsAppResolveTemplateParametersPathParams['templateId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateWhatsAppResolveTemplateParametersResponse,
					AxiosError<CandidateWhatsAppResolveTemplateParametersError>,
					TSelectData,
					CandidateWhatsAppResolveTemplateParametersQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateWhatsAppResolveTemplateParametersError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateWhatsAppResolveTemplateParametersQueryOptions(candidateId, templateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
